import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Block from '@mui/icons-material/Block';
import BuildCircle from '@mui/icons-material/BuildCircle';
import { usePortalAuthContext } from '../../contexts/portalAuth';
import { CLIENT_PORTAL_MODULE } from '../../types/portal';
import { PortalSectionHeader } from './portalSectionHeader.component';
import { PortalTicketForm } from './portalTicketForm.component';
import styles from './portal.module.css';

export const PortalTicket = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { slug, hasModule } = usePortalAuthContext();
  const [formKey, setFormKey] = useState(0);

  const canReport = hasModule(CLIENT_PORTAL_MODULE.TECH_SUPPORT);
  // Reporting and the jobs list share one module, so this is the same flag.
  const canSeeJobs = canReport;

  if (!canReport) {
    return (
      <Box className={styles.placeholder}>
        <Block sx={{ fontSize: 40 }} />
        <Typography variant="body2">
          {t('Your service provider has not enabled this section.')}
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <PortalSectionHeader
        icon={<BuildCircle />}
        title={t('Report a fault')}
        description={t('Tell us which machines are affected and what is wrong with them.')}
      />
      <Box sx={{ mt: 3 }}>
        <PortalTicketForm
          key={formKey}
          onDone={() => {
            // The jobs list is where a report lives once it is sent.
            if (canSeeJobs) {
              navigate(`/portal/${slug}/jobs`);
              return;
            }
            // No list to follow it on: start the form over instead.
            setFormKey((value) => value + 1);
          }}
        />
      </Box>
    </>
  );
};
